import { offlineDB } from "./db";

/* SEARCH PRODUCT */
export const searchOfflineProducts = async q => {
  return offlineDB.products
    .where("barcode")
    .startsWithIgnoreCase(q)
    .or("name")
    .startsWithIgnoreCase(q)
    .toArray();
};

/* CHECK STOCK */
export const checkOfflineStock = async (branchId, items) => {
  if (!branchId) {
    throw new Error("Branch not assigned");
  }

  const issues = [];

  for (const item of items) {
    const stock = await offlineDB.inventory.get([
      branchId,
      item.product_id
    ]);

    if (!stock || stock.quantity < item.quantity) {
      issues.push({
        product_id: item.product_id,
        available: stock?.quantity || 0,
        requested: item.quantity
      });
    }
  }

  if (issues.length) {
    throw { error: "INSUFFICIENT_STOCK", issues };
  }
};

/* REDUCE STOCK */
export const reduceOfflineStock = async (branchId, cart) => {
  for (const item of cart) {
    const stock = await offlineDB.inventory
      .where("product_id")
      .equals(item.product_id)
      .and(s => s.branch_id === branchId)
      .first();

    if (!stock) continue;

    await offlineDB.inventory.update(stock.id, {
      quantity: Number(stock.quantity) - Number(item.quantity)
    });
  }
};

/* SAVE OFFLINE INVOICE */
export const saveOfflineInvoice = async (payload, branch) => {
  const id = await offlineDB.invoices.add({
    invoice_number: `OFF-${Date.now()}`,
    created_at: Date.now(),

    bill_type: payload.bill_type,
    payment_mode: payload.payment_mode,

    subtotal: payload.subtotal,
    discount_type: payload.discount_type,
    discount_value: payload.discount_value,
    discount_amount: payload.discount_amount,
    grand_total: payload.grand_total,

    customer_name: payload.customer_name || null,
    customer_mobile: payload.customer_mobile || null,

    created_by_name: payload.created_by_name,

    branch, // 🔥 FULL BRANCH OBJECT

    items: payload.items.map(i => ({
      product_id: i.product_id,
      product_name: i.product_name, // 🔥 CRITICAL
      quantity: i.quantity,
      price: i.price,
      total: i.total
    })),

    synced: 0
  });

  return id;
};



